import { Policies } from "@stories/pages/Contractor/Policies/Policies";

export const PoliciesView = () => {
  return <Policies />;
};
